import React, { FunctionComponent, useEffect, useRef } from "react";
import { useState } from "react";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddContacts/AddContacts.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
// import { fetchFAQ, updateFAQ } from "../../Services/resources";
import {updateFAQ } from "../../Services/faq";
import { useLocation } from "react-router-dom";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import { googleAnalytics } from "../../Services/users";

type props = {
  history: any;
  user: any;
  propsData: any;
  theme: any;
  authToken: any;
};
const EditFAQ: FunctionComponent<props> = ({ history, user, propsData, theme, authToken }) => {
  const location = useLocation();
  const [load, setLoad] = useState(false);
  const [faqList, setfaqList] = useState<any[] | undefined>(undefined);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [sNumber, setSNumber] = useState("");
  const [number, setNumber] = useState("");
  const [Id, setId] = useState("");
  const [allData, setAllData] = useState<any[]>([]);
  const dispatcher = useDispatch();
  const questionRef: any = useRef();
  const answerRef: any = useRef();
  const srNumberRef: any = useRef();

  useEffect(() => {
    if (location.state) {
      const data: any = location?.state;
      setQuestion(data.item.question);
      setAnswer(data.item.answer);
      setId(data.item._id);
    }
  }, [location]);

  const handleCheck = () => {
    if (questionRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Question!!", "error"));
      return false;
    } else if (answerRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Answer!!", "error"));
      return false;
    }
    else {
      return true;
    }
  };

  const update = (e: any) => {
    e.preventDefault();
    const val = handleCheck();
    if (val) {
      setLoad(true);
      updateFAQ(
        question,
        answer,
        user.uid,
        Id,
        dispatcher,
        (data: boolean) => setLoad(data),
        history,
        authToken
      );
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const [isGACalled, setIsGACalled] = useState<any>(false);
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Edit_FAQ_Screen',user)
      }
    }
  },[user])

  return (
    <div className="container-fluid p-4 d-flex flex-column gap-4" style={containerStyles}>
      <h3>Edit FAQ</h3>
      <div className="w-100 d-flex flex-column gap-2" style={cardContainerStyles}>
        <form className="card p-4 shadow rounded" style={cardContainerStyles}>
        <div className="mb-3">
            <Label label="Question" required />
            <input
              type="email"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              ref={questionRef}
              onChange={(e) => setQuestion(e.target.value)}
              value={question}
              placeholder={"Enter Question"}
            />
          </div>
        {/* <div style={{display:'flex',justifyContent:"space-between",gap:"0.5rem"}}>
          <div className="mb-3 col-0.4">
            <Label label="S.NO" required />
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              ref={srNumberRef}
              onChange={(e) => setSNumber(e.target.value)}
              value={sNumber}
            />
          </div>
        
          </div> */}
          <div className="mb-3">
            <Label label="Answer" required />
            <textarea
              className="form-control"
              id="exampleInputPassword1"
              rows={5}
              ref={answerRef}
              onChange={(e) => setAnswer(e.target.value)}
              value={answer}
            />
          </div>
          <button
            type="submit"
            // className="btn btn-primary mt-5"
            className={styles.button}
            style={{ backgroundColor: "#279f9f" }}
            onClick={(e) => update(e)}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(EditFAQ);